import Factory from './paywall-factory';

class Notifier {
  static init() {
    // Crear los distintos de Alertas
    this.alerts = Factory.createAlerts(...arguments);

    // Ordenar las alertas por prioridad de ser ejecutadas
    this.alerts.sort((a, b) => {
      return a.priority - b.priority;
    });

    for (let i = 0; i < this.alerts.length; i++) {
      let alert = this.alerts[i];
      if (alert.show() && alert.final === true) {
        break;
      }
    }
  }
}

export default Notifier;



// WEBPACK FOOTER //
// ./src/paywall-notifier.js